import * as React from 'react';
import LinearProgress, {
    LinearProgressProps
} from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


export const LinearProgressWithLabel = (
    props: LinearProgressProps & { value: number, numerator: number, denominator: number, width: number}
) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Box sx={{ minWidth: 30 }}>
            <Typography
                variant='body2'
                color='text.secondary'
            >{props.numerator > props.denominator ? `${props.numerator}` : `${props.numerator}/${props.denominator}`}</Typography>
        </Box>
        <Box sx={{ width: props.width}}>
            <LinearProgress color={props.value === 100 ? 'success' : 'primary'} variant='determinate' {...props} />
        </Box>
    </Box>
);

